import ContentLoader from 'react-content-loader';

const ProductSingleDetailsLoader = ({
  lang,
  ...props
}: { lang?: string } & any) => (
  <div className="pt-6 pb-2 md:pt-7">
    <div className="grid-cols-10 lg:grid gap-7 2xl:gap-8">
      {/* Left side - Image/Gallery */}
      <div className="col-span-5 mb-6 xl:col-span-6 md:mb-8 lg:mb-0 relative">
        <ContentLoader
          speed={2}
          width={700}
          height={400}
          viewBox="0 0 700 400"
          backgroundColor="#F3F6FA"
          foregroundColor="#E7ECF3"
          className="w-full h-auto rounded-lg overflow-hidden border border-gray-100"
          {...props}
        >
          <rect x="0" y="0" rx="0" ry="0" width="700" height="400" />
        </ContentLoader>
      </div>

      {/* Right side - Product Details */}
      <div className="flex flex-col col-span-5 shrink-0 xl:col-span-4 xl:ltr:pl-2 xl:rtl:pr-2">
        <div className="pb-3 lg:pb-5">
          <ContentLoader
            speed={2}
            width={400}
            height={250}
            viewBox="0 0 400 250"
            backgroundColor="#F3F6FA"
            foregroundColor="#E7ECF3"
            className="w-full h-auto"
            {...props}
          >
            {/* Product title */}
            <rect x="0" y="0" rx="3" ry="3" width="300" height="25" />
            <rect x="0" y="35" rx="3" ry="3" width="150" height="15" />
            <rect x="0" y="60" rx="3" ry="3" width="200" height="15" />
            <rect x="0" y="85" rx="3" ry="3" width="250" height="15" />

            {/* Price */}
            <rect x="0" y="120" rx="3" ry="3" width="100" height="25" />
            <rect x="110" y="120" rx="3" ry="3" width="80" height="25" />

            {/* Attributes */}
            <rect x="0" y="160" rx="3" ry="3" width="300" height="40" />

            {/* Counter and Add to Cart */}
            <rect x="0" y="215" rx="3" ry="3" width="120" height="35" />
            <rect x="130" y="215" rx="3" ry="3" width="270" height="35" />
          </ContentLoader>
        </div>
      </div>
    </div>

    {/* Product Details Tab */}
    <div className="mt-8">
      <ContentLoader
        speed={2}
        width={1000}
        height={100}
        viewBox="0 0 1000 100"
        backgroundColor="#F3F6FA"
        foregroundColor="#E7ECF3"
        className="w-full h-auto rounded-md overflow-hidden"
        {...props}
      >
        <rect x="0" y="0" rx="3" ry="3" width="150" height="30" />
        <rect x="160" y="0" rx="3" ry="3" width="150" height="30" />
        <rect x="0" y="40" rx="0" ry="0" width="1000" height="2" />
        <rect x="0" y="50" rx="3" ry="3" width="1000" height="50" />
      </ContentLoader>
    </div>
  </div>
);

export default ProductSingleDetailsLoader;
